<template>
  <div id="app">
    <FlashMessage></FlashMessage>
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
    import appHeader from './views/common/Header.vue'
    import appFooter from './views/common/Footer.vue'

    export default {
        name: 'app',
        components: {
            appHeader,
            appFooter
        }
    }
</script>




